import React from 'react';
import { Nav, Navbar, NavDropdown, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import logo from '../../../img/logo.png';
import { showStats } from '../../../reducers/currentUser/currentUser.reducer';
import './AdminHeader.css';

export const AdminHeader = () => (
  <Navbar staticTop >
    <Navbar.Header>
      <Navbar.Brand>
        <a href="/admin" ><img src={logo} alt="logo" className="logo" /> Admin</a>
      </Navbar.Brand>
      <Navbar.Toggle />
    </Navbar.Header>
    <Navbar.Collapse>
      <Nav pullLeft >
        <LinkContainer exact to="/admin/" ><NavItem>Home</NavItem></LinkContainer>
        <NavDropdown title="DWRs" >
          <LinkContainer to="/admin/dwrs/approved" ><NavItem>Approved</NavItem></LinkContainer>
          <LinkContainer to="/admin/dwrs/submitted" ><NavItem>Submitted</NavItem></LinkContainer>
        </NavDropdown>
        <NavDropdown title="Admin" >
          <LinkContainer to="/admin/clients/" ><NavItem>Clients</NavItem></LinkContainer>
          <LinkContainer to="/admin/costcodes" ><NavItem>Cost Codes</NavItem></LinkContainer>
          <LinkContainer to="/admin/costcodecategories" ><NavItem>Cost Code Categories</NavItem></LinkContainer>
          <LinkContainer to="/admin/employees" ><NavItem>Employees</NavItem></LinkContainer>
          <LinkContainer to="/admin/equipment" ><NavItem>Equipment</NavItem></LinkContainer>
          <LinkContainer to="/admin/equipment_categories" ><NavItem>Equipment Categories</NavItem></LinkContainer>
          <LinkContainer to="/admin/laborClasses" ><NavItem>Labor Classes</NavItem></LinkContainer>
          <LinkContainer to="/admin/paymentTypes" ><NavItem>Payment Types</NavItem></LinkContainer>
          <LinkContainer to="/admin/projects" ><NavItem>Projects</NavItem></LinkContainer>
          <LinkContainer to="/admin/subcontractors" ><NavItem>Sub-Contractors</NavItem></LinkContainer>
        </NavDropdown>
        {showStats() && <LinkContainer exact to="/admin/stats" ><NavItem>Stats</NavItem></LinkContainer>}
        <LinkContainer to="/logout" ><NavItem>Logout</NavItem></LinkContainer>
      </Nav>
    </Navbar.Collapse>
  </Navbar>
);



// WEBPACK FOOTER //
// ./src/components/Admin/Header/AdminHeader.jsx